// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.more-we-offer-section {
  padding: 4rem 0;
  margin: 0 auto;
}
.more-we-offer-section .more-we-offer-wrap {
  width: 100%;
  max-width: var(--containerWidth);
  margin: 0 auto;
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .cards-grid {
  --cards-grid-number: 4;
  --cards-grid-gap: 1.25rem;
  display: grid;
  grid-template-columns: repeat(var(--cards-grid-number), 1fr);
  gap: var(--cards-grid-gap);
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card {
  width: 100%;
  height: 100%;
  background-color: var(--white-1000);
  border: 1px solid var(--black-200);
  border-radius: 0.75rem;
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  padding: 1.25rem 1.5rem;
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header {
  width: 100%;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 1.5rem;
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .icon-box {
  width: 4rem;
  min-width: 4rem;
  height: 4rem;
  display: flex;
  justify-content: center;
  align-items: center;
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .icon-box img {
  width: 100%;
  min-width: 100%;
  height: 100%;
  object-fit: contain;
  object-position: center;
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .title-text {
  color: var(--black-1000);
  font-size: 1.5rem;
  font-weight: 600;
  line-height: 1.4;
}
.more-we-offer-section .more-we-offer-wrap .more-we-offer-box .btn-box {
  display: flex;
  justify-content: center;
  margin-top: 4rem;
}
@media screen and (max-width: 991.98px) {
  .more-we-offer-section {
    padding: 2.5rem 0;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1.125rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card {
    border-radius: 0.75rem;
    gap: 1rem;
    padding: 1rem 1.25rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .icon-box {
    width: 2.75rem;
    min-width: 2.75rem;
    height: 2.75rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .title-text {
    font-size: 1rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .btn-box {
    margin-top: 2.5rem;
  }
}
@media screen and (max-width: 767.98px) {
  .more-we-offer-section {
    padding: 2rem 0;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .cards-grid {
    --cards-grid-number: 2;
    --cards-grid-gap: 1rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card {
    border-radius: 0.75rem;
    gap: 1rem;
    padding: 1rem 1.25rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header {
    gap: 1rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .icon-box {
    width: 2.25rem;
    min-width: 2.25rem;
    height: 2.25rem;
    border-radius: 0.25rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .card .card-header .title-text {
    font-size: 0.875rem;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .btn-box {
    margin-top: 1.25rem;
  }
}
@media screen and (max-width: 474.98px) {
  .more-we-offer-section {
    padding: 2rem 0;
  }
  .more-we-offer-section .more-we-offer-wrap .more-we-offer-box .cards-grid {
    --cards-grid-number: 1;
    --cards-grid-gap: 1rem;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/MoreWeOfferSection/MoreWeOfferStyle.scss"],"names":[],"mappings":"AAAA;EACE,eAAA;EACA,cAAA;AACF;AACE;EACE,WAAA;EACA,gCAAA;EACA,cAAA;AACJ;AAEM;EACE,sBAAA;EACA,yBAAA;EACA,aAAA;EACA,4DAAA;EACA,0BAAA;AAAR;AAGM;EACE,WAAA;EACA,YAAA;EACA,mCAAA;EACA,kCAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,YAAA;EACA,uBAAA;AADR;AAGQ;EACE,WAAA;EACA,aAAA;EACA,2BAAA;EACA,mBAAA;EACA,WAAA;AADV;AAGU;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;AADZ;AAGY;EACE,WAAA;EACA,eAAA;EACA,YAAA;EACA,mBAAA;EACA,uBAAA;AADd;AAKU;EACE,wBAAA;EACA,iBAAA;EACA,gBAAA;EACA,gBAAA;AAHZ;AAQM;EACE,aAAA;EACA,uBAAA;EACA,gBAAA;AANR;AAWE;EAtEF;IAuEI,iBAAA;EARF;EAYM;IACE,sBAAA;IACA,0BAAA;EAVR;EAaM;IACE,sBAAA;IACA,SAAA;IACA,qBAAA;EAXR;EAcU;IACE,cAAA;IACA,kBAAA;IACA,eAAA;EAZZ;EAeU;IACE,eAAA;EAbZ;EAkBM;IACE,kBAAA;EAhBR;AACF;AAqBE;EAzGF;IA0GI,eAAA;EAlBF;EAsBM;IACE,sBAAA;IACA,sBAAA;EApBR;EAuBM;IACE,sBAAA;IACA,SAAA;IACA,qBAAA;EArBR;EAuBQ;IACE,SAAA;EArBV;EAuBU;IACE,cAAA;IACA,kBAAA;IACA,eAAA;IACA,sBAAA;EArBZ;EAwBU;IACE,mBAAA;EAtBZ;EA2BM;IACE,mBAAA;EAzBR;AACF;AA8BE;EA/IF;IAgJI,eAAA;EA3BF;EA+BM;IACE,sBAAA;IACA,sBAAA;EA7BR;AACF","sourcesContent":[".more-we-offer-section {\n  padding: 4rem 0;\n  margin: 0 auto;\n\n  .more-we-offer-wrap {\n    width: 100%;\n    max-width: var(--containerWidth);\n    margin: 0 auto;\n\n    .more-we-offer-box {\n      .cards-grid {\n        --cards-grid-number: 4;\n        --cards-grid-gap: 1.25rem;\n        display: grid;\n        grid-template-columns: repeat(var(--cards-grid-number), 1fr);\n        gap: var(--cards-grid-gap);\n      }\n\n      .card {\n        width: 100%;\n        height: 100%;\n        background-color: var(--white-1000);\n        border: 1px solid var(--black-200);\n        border-radius: 0.75rem;\n        display: flex;\n        flex-direction: column;\n        gap: 1.25rem;\n        padding: 1.25rem 1.5rem;\n\n        .card-header {\n          width: 100%;\n          display: flex;\n          justify-content: flex-start;\n          align-items: center;\n          gap: 1.5rem;\n\n          .icon-box {\n            width: 4rem;\n            min-width: 4rem;\n            height: 4rem;\n            display: flex;\n            justify-content: center;\n            align-items: center;\n\n            img {\n              width: 100%;\n              min-width: 100%;\n              height: 100%;\n              object-fit: contain;\n              object-position: center;\n            }\n          }\n\n          .title-text {\n            color: var(--black-1000);\n            font-size: 1.5rem;\n            font-weight: 600;\n            line-height: 1.4;\n          }\n        }\n      }\n\n      .btn-box {\n        display: flex;\n        justify-content: center;\n        margin-top: 4rem;\n      }\n    }\n  }\n\n  @media screen and (max-width: 991.98px) {\n    padding: 2.5rem 0;\n\n    .more-we-offer-wrap {  \n      .more-we-offer-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1.125rem;\n        }\n  \n        .card {\n          border-radius: 0.75rem;\n          gap: 1rem;\n          padding: 1rem 1.25rem;\n        \n          .card-header {\n            .icon-box {\n              width: 2.75rem;\n              min-width: 2.75rem;\n              height: 2.75rem;\n            }\n  \n            .title-text {\n              font-size: 1rem;\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 2.5rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 767.98px) {\n    padding: 2rem 0;\n\n    .more-we-offer-wrap {  \n      .more-we-offer-box {\n        .cards-grid {\n          --cards-grid-number: 2;\n          --cards-grid-gap: 1rem;\n        }\n  \n        .card {     \n          border-radius: 0.75rem;\n          gap: 1rem;\n          padding: 1rem 1.25rem;\n\n          .card-header { \n            gap: 1rem;\n            \n            .icon-box {\n              width: 2.25rem;\n              min-width: 2.25rem;\n              height: 2.25rem;\n              border-radius: 0.25rem;\n            }\n\n            .title-text {\n              font-size: 0.875rem;\n            }\n          }\n        }\n  \n        .btn-box {\n          margin-top: 1.25rem;\n        }\n      }\n    }\n  }\n\n  @media screen and (max-width: 474.98px) {\n    padding: 2rem 0;\n\n    .more-we-offer-wrap {  \n      .more-we-offer-box {\n        .cards-grid {\n          --cards-grid-number: 1;\n          --cards-grid-gap: 1rem;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
